<template>
  <div class="pg-index">
    <div class="main">
      <a class="logo" />
      <a class="go_site" href="/act/wegamedata/index.html#/index">返回首页</a>
      <!-- 导航 -->
      <div class="left_bn">
        <span class="tit">仙侠指南</span>
        <ul>
          <li v-for="info in gameList" :key="info.id">
            <span class="guide_tit">{{ info.name }}</span>
            <div class="content">
              <a v-for="item in info.list" :key="item.id" @click="goinfo(item.id)">{{ item.name }}</a>
            </div>
          </li>
        </ul>
      </div>
      <!-- 内容 -->
      <div class="main_con">
        <div class="tit">
          <span class="path">
            您的位置：<a href="/act/wegamedata/index.html#/index">首页</a>&gt;<a>搜索</a>
          </span>
        </div>
        <div class="main_info">
          <!-- 搜索 -->
          <div class="search_main">
            <input v-model="searchkey" type="text" class="search_name"><a class="search" @click="searchInfo()">搜索</a>
          </div>
          <div class="searchResult">
            <ul>
              <li v-for="info in searchList" :key="info.article_id">
                <a target="_blank" class="link" @click="goinfo(info.article_id)" v-html="info.title" />
                <div class="txts" v-html="info.content" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="clr" />
    <RightLe class="rightLe" />
    <Footer class="footer" />
  </div>
</template>
<script>
import Vue from 'vue'
import VueJsonp from 'vue-jsonp'
import api from '~/api/api';
import Footer from '~/components/Footer/footer.vue';
import RightLe from '~/components/RightLe/rightLe.vue';
import { trim } from '~/tools/utils';
Vue.use(VueJsonp);

export default {
  components: {
    Footer,
    RightLe
  },
  data() {
    return {
      gameList: '',
      searchkey: this.$route.params.keyword,
      searchList: ''
    }
  },
  mounted() {
    this.initData();
    this.searchInfo();
  },
  methods: {
    goinfo: function(id) {
      this.$router.push({
        path: `/info/${id}`
      })
    },
    initData: function() {
      api.getList().then(reslist => {
        this.gameList = reslist.data;
      })
    },
    search: function() {
      let skey = trim(this.searchkey);
      if (skey) {
        this.$router.push({
          path: `/search/${skey}`
        })
      } else {
        alert('请输入搜索信息');
      }
    },
    searchInfo() {
      let params = {};
      params['callbackQuery'] = 'jsoncallback';
      params['project'] = 'site_xx2wegame';
      params['game_type'] = 45;
      params['limit'] = 200;
      params['start'] = 0;
      params['keyword'] = trim(this.searchkey);
      this.$jsonp('https://sapi.ztgame.com/search/search', params).then(
        (data) => {
          this.searchList = data.list;
        })
    }
  }
}
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  @import '../../../assets/stylus/minixs/_center.styl';
  .pg-index{
    position relative;
    width 100%;
    min-height 1970px;
    background #f4fcff url('./images/bg.jpg') no-repeat top center;
    margin 0 auto;
    .main{
      width 1306px;
      height 100%;
      margin 0 auto;
    }
    .clr{
      clear both;
    }
    .logo{
      width 458px;
      height 92px;
      display inline-block;
      position relative;
      margin-top 27px;
      margin-left 41px;
      background url('./images/logo.png') no-repeat;
    }
    .go_site{
      width 98px;
      height 30px;
      display block;
      margin-top 340px;
      margin-left 28px;
      background url('./images/go_site.png') no-repeat;
      text-indent -9999px;
      cursor pointer;
    }
    .left_bn{
      width 278px;
      height auto;
      background #4ea0cf;
      margin-top 18px;
      margin-left 27px;
      position relative;
      float left;
      .tit{
        display inline-block;
        width 126px;
        height 24px;
        background url('./images/guide_xx.png') no-repeat;
        margin-left 68px;
        margin-top 20px;
        margin-bottom 17px;
        text-indent -9999px;
      }
      li{
        width 100%;
        min-height 70px;
        border-top 1px solid #6ccee6;
        color #fff;
        padding-bottom 16px;
        .guide_tit{
          display block;
          width 100%;
          height 16px;
          font-size 16px;
          margin-top 13px;
          margin-left 27px;
        }
        .content{
          width 240px;
          margin-left 27px;
          a{
            display inline-block;
            font-size 14px;
            margin-right 14px;
            margin-top 11px;
            cursor pointer;
          }
        }
      }
      li:nth-of-type(odd){
        background #4798ca;
      }
      li:hover,li.on{
        width 285px;
        margin-left -7px;
        background #e9d6a7;
        color #333;
      }
    }
    .main_con{
      width 970px;
      min-height 1230px;
      float left;
      border 2px solid #b6e0f8;
      background #fcfcfd;
      margin-left 12px;
      margin-top 20px;
      margin-bottom: 87px;
      .tit{
        width 967px
        height 58px;
        line-height 58px;
        background url('./images/conbg.png') no-repeat;
        font-size 14px;
        color #666666;
        .path{
          margin-left 27px;
          float left;
          a{
            text-decoration none;
            color #666666;
          }
        }
      }
      .main_info{
        overflow hidden;
        padding 28px;
        margin:0 auto;
        .search_main{
          margin 26px 0 30px 114px;
          overflow hidden;
          .search_name{
            float left;
            width 584px;
            height 38px;
            line-height 36px;
            border 1px solid #b6e0f8;
            margin 0;
            margin-right 15px;
            font-size 16px;
            color #556677;
            text-indent 1em;
            padding 0;
          }
          .search{
            float left;
            width 100px;
            height 38px;
            line-height 38px;
            background-color #556677;
            text-align center;
            border-radius 5px;
            font-size 16px;
            color #fff;
            margin 0;
            padding 0;
            cursor pointer;
          }
        }
        .searchResult{
          width: 810px;
          margin:0 auto;
          li{
            width: 100%;
            padding-bottom: 16px;
            border-bottom: 1px dashed #d6dee6;
            a{
              font-size: 16px;
              color: #556677;
              line-height: 36px;
              text-decoration: underline;
            }
            .txts{
              font-size: 14px;
              line-height: 24px;
              color: #556677;
            }
          }
        }
      }
    }
  }
</style>
